import React, { useEffect, useState, useMemo } from 'react';
import api from '../utils/api';

const S = {
  input:    { padding: '7px 10px', border: '1px solid #DDD', borderRadius: 6, fontSize: 13, width: '100%', boxSizing: 'border-box' },
  btnBlue:  { padding: '7px 14px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' },
  btnGreen: { padding: '6px 12px', background: '#1A7A3C', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap' },
  btnGhost: { padding: '5px 11px', background: 'none', border: '1px solid #DDD', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#555' },
  btnRed:   { padding: '5px 11px', background: 'none', border: '1px solid #E05040', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#C0392B' },
  btnOrange:{ padding: '5px 11px', background: '#FDF3E3', border: '1px solid #F0A500', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#B5660E' },
  editBox:  { background: '#F7F9FC', border: '1px solid #C5D8F0', borderRadius: 8, padding: 14, marginTop: 4, marginBottom: 4 },
};

function Fout({ tekst }) {
  if (!tekst) return null;
  return <div style={{ padding: '8px 12px', background: '#FDEDEC', border: '1px solid #E05040', borderRadius: 6, fontSize: 13, color: '#B03020', marginTop: 8 }}>{tekst}</div>;
}

function ZoekToggle({ zoek, setZoek, toonInactief, setToonInactief, placeholder, aantalInactief }) {
  return (
    <div style={{ display: 'flex', gap: 10, marginBottom: 12, alignItems: 'center', flexWrap: 'wrap' }}>
      <input value={zoek} onChange={e => setZoek(e.target.value)} placeholder={placeholder || 'Zoeken...'}
        style={{ flex: 1, minWidth: 180, padding: '7px 12px', border: '1px solid #DDD', borderRadius: 6, fontSize: 13 }} />
      {aantalInactief > 0 && (
        <button onClick={() => setToonInactief(t => !t)} style={{
          padding: '6px 12px', border: '1px solid #DDD', borderRadius: 6, fontSize: 12, cursor: 'pointer',
          background: toonInactief ? '#F4F4F4' : '#fff', color: '#666',
        }}>
          {toonInactief ? `Verberg inactief (${aantalInactief})` : `Toon inactief (${aantalInactief})`}
        </button>
      )}
    </div>
  );
}

function TabelHdr({ kolommen }) {
  return (
    <div style={{ background: '#1F3864', color: '#fff', padding: '8px 14px', display: 'grid', gridTemplateColumns: kolommen, fontSize: 11, fontWeight: 500 }}>
      {Object.values(kolommen.labels || {}).map(h => <div key={h}>{h}</div>)}
    </div>
  );
}

// ─── OPERATIES ────────────────────────────────────────────────────────────────
function OperatiesTab({ onTel }) {
  const [lijst, setLijst]       = useState([]);
  const [nieuw, setNieuw]       = useState({ naam: '', categorie: '', is_extern: false });
  const [bewerk, setBewerk]     = useState(null);
  const [fout, setFout]         = useState('');
  const [bezig, setBezig]       = useState(false);
  const [zoek, setZoek]         = useState('');
  const [toonInactief, setToonInactief] = useState(false);

  const laad = () => api.get('/operaties').then(r => { setLijst(r.data); });
  useEffect(() => { laad(); }, []);
  useEffect(() => { onTel?.(lijst.filter(o => o.actief).length); }, [lijst]);

  const voegToe = async () => {
    if (!nieuw.naam) return;
    setBezig(true); setFout('');
    try {
      const maxNr = Math.max(0, ...lijst.map(o => o.nummer));
      await api.post('/operaties', { ...nieuw, nummer: maxNr + 1 });
      setNieuw({ naam: '', categorie: '', is_extern: false });
      laad();
    } catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const slaOp = async () => {
    setBezig(true); setFout('');
    try { await api.put(`/operaties/${bewerk.id}`, bewerk); setBewerk(null); laad(); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const toggleActief = async (o) => {
    await api.put(`/operaties/${o.id}`, { ...o, actief: !o.actief }); laad();
  };

  const inactiefAantal = lijst.filter(o => !o.actief).length;
  const gefilterd = useMemo(() => lijst.filter(o => {
    if (!toonInactief && !o.actief) return false;
    if (zoek) { const q = zoek.toLowerCase(); return `${o.naam} ${o.categorie || ''} ${o.nummer}`.toLowerCase().includes(q); }
    return true;
  }), [lijst, zoek, toonInactief]);

  return (
    <div>
      {/* Nieuw formulier */}
      <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 8, padding: 16, marginBottom: 16 }}>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, color: '#1F3864' }}>Nieuwe operatie</div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ flex: 2, minWidth: 160 }}>
            <input style={S.input} placeholder="Naam *" value={nieuw.naam} onChange={e => setNieuw(p => ({ ...p, naam: e.target.value }))} />
          </div>
          <div style={{ flex: 1, minWidth: 120 }}>
            <input style={S.input} placeholder="Categorie" value={nieuw.categorie} onChange={e => setNieuw(p => ({ ...p, categorie: e.target.value }))} />
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, whiteSpace: 'nowrap', cursor: 'pointer' }}>
            <input type="checkbox" checked={nieuw.is_extern} onChange={e => setNieuw(p => ({ ...p, is_extern: e.target.checked }))} /> Extern
          </label>
          <button style={S.btnBlue} onClick={voegToe} disabled={bezig || !nieuw.naam}>+ Toevoegen</button>
        </div>
        <Fout tekst={fout} />
      </div>

      <ZoekToggle zoek={zoek} setZoek={setZoek} toonInactief={toonInactief} setToonInactief={setToonInactief}
        placeholder="Zoeken op naam, categorie, nummer..." aantalInactief={inactiefAantal} />

      <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 8, overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '48px 1fr 140px 70px 80px 110px', background: '#1F3864', color: '#fff', padding: '8px 14px', fontSize: 11, fontWeight: 500, gap: 0 }}>
          {['Nr.', 'Naam', 'Categorie', 'Extern', 'Status', ''].map(h => <div key={h}>{h}</div>)}
        </div>
        {gefilterd.length === 0 && (
          <div style={{ padding: '20px 14px', color: '#AAA', fontStyle: 'italic', fontSize: 13 }}>Geen operaties gevonden</div>
        )}
        {gefilterd.map((o, i) => (
          <div key={o.id} style={{ background: i % 2 === 0 ? '#fff' : '#FAFAFA', borderBottom: '1px solid #F0F0F0', padding: '10px 14px', opacity: o.actief ? 1 : 0.6 }}>
            {bewerk?.id === o.id ? (
              <div style={S.editBox}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                  <div><label style={{ fontSize: 11, color: '#666' }}>Naam</label><input style={S.input} value={bewerk.naam} onChange={e => setBewerk(p => ({ ...p, naam: e.target.value }))} /></div>
                  <div><label style={{ fontSize: 11, color: '#666' }}>Categorie</label><input style={S.input} value={bewerk.categorie || ''} onChange={e => setBewerk(p => ({ ...p, categorie: e.target.value }))} /></div>
                  <div><label style={{ fontSize: 11, color: '#666' }}>Externe partij</label><input style={S.input} value={bewerk.externe_partij || ''} onChange={e => setBewerk(p => ({ ...p, externe_partij: e.target.value }))} /></div>
                  <div style={{ display: 'flex', gap: 20, alignItems: 'center', paddingTop: 18 }}>
                    <label style={{ fontSize: 13, display: 'flex', gap: 5, alignItems: 'center', cursor: 'pointer' }}><input type="checkbox" checked={bewerk.is_extern} onChange={e => setBewerk(p => ({ ...p, is_extern: e.target.checked }))} /> Extern</label>
                    <label style={{ fontSize: 13, display: 'flex', gap: 5, alignItems: 'center', cursor: 'pointer' }}><input type="checkbox" checked={bewerk.actief} onChange={e => setBewerk(p => ({ ...p, actief: e.target.checked }))} /> Actief</label>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button style={S.btnGreen} onClick={slaOp} disabled={bezig}>Opslaan</button>
                  <button style={S.btnGhost} onClick={() => { setBewerk(null); setFout(''); }}>Annuleren</button>
                </div>
                <Fout tekst={fout} />
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: '48px 1fr 140px 70px 80px 110px', alignItems: 'center', gap: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#185FA5' }}>{o.nummer}</div>
                <div style={{ fontSize: 13, fontWeight: 500, color: o.actief ? '#1F3864' : '#AAA' }}>{o.naam}</div>
                <div style={{ fontSize: 12, color: '#666' }}>{o.categorie || '—'}</div>
                <div>{o.is_extern ? <span style={{ fontSize: 11, color: '#854F0B' }}>Extern</span> : <span style={{ color: '#CCC' }}>—</span>}</div>
                <div>
                  <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 99, background: o.actief ? '#EAF3DE' : '#F4F4F4', color: o.actief ? '#27500A' : '#AAA' }}>
                    {o.actief ? 'Actief' : 'Inactief'}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: 5 }}>
                  <button style={S.btnGhost} onClick={() => { setBewerk({ ...o }); setFout(''); }}>Bewerk</button>
                  <button style={{ ...S.btnGhost, color: o.actief ? '#C0392B' : '#1A7A3C', borderColor: o.actief ? '#E05040' : '#82C96B' }} onClick={() => toggleActief(o)}>
                    {o.actief ? 'Deact.' : 'Activeer'}
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <div style={{ marginTop: 8, fontSize: 12, color: '#AAA' }}>{gefilterd.length} van {lijst.length} operaties</div>
    </div>
  );
}

// ─── PRODUCTFAMILIES ──────────────────────────────────────────────────────────
function FamiliesTab({ onTel }) {
  const [lijst, setLijst]   = useState([]);
  const [nieuw, setNieuw]   = useState({ naam: '', beschrijving: '', kleur: '#185FA5' });
  const [bewerk, setBewerk] = useState(null);
  const [fout, setFout]     = useState('');
  const [bezig, setBezig]   = useState(false);
  const [zoek, setZoek]     = useState('');
  const [toonInactief, setToonInactief] = useState(false);

  const laad = () => api.get('/productfamilies').then(r => setLijst(r.data));
  useEffect(() => { laad(); }, []);
  useEffect(() => { onTel?.(lijst.filter(f => f.actief).length); }, [lijst]);

  const voegToe = async () => {
    if (!nieuw.naam) return;
    setBezig(true); setFout('');
    try { await api.post('/productfamilies', nieuw); setNieuw({ naam: '', beschrijving: '', kleur: '#185FA5' }); laad(); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const slaOp = async () => {
    setBezig(true); setFout('');
    try { await api.put(`/productfamilies/${bewerk.id}`, bewerk); setBewerk(null); laad(); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const toggleActief = async (f) => {
    await api.put(`/productfamilies/${f.id}`, { ...f, actief: !f.actief }); laad();
  };

  const inactiefAantal = lijst.filter(f => !f.actief).length;
  const gefilterd = useMemo(() => lijst.filter(f => {
    if (!toonInactief && !f.actief) return false;
    if (zoek) return `${f.naam} ${f.beschrijving || ''}`.toLowerCase().includes(zoek.toLowerCase());
    return true;
  }), [lijst, zoek, toonInactief]);

  return (
    <div>
      <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 8, padding: 16, marginBottom: 16 }}>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, color: '#1F3864' }}>Nieuwe productfamilie</div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ flex: 1, minWidth: 140 }}><input style={S.input} placeholder="Naam *" value={nieuw.naam} onChange={e => setNieuw(p => ({ ...p, naam: e.target.value }))} /></div>
          <div style={{ flex: 2, minWidth: 180 }}><input style={S.input} placeholder="Beschrijving" value={nieuw.beschrijving} onChange={e => setNieuw(p => ({ ...p, beschrijving: e.target.value }))} /></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <label style={{ fontSize: 12, color: '#666' }}>Kleur</label>
            <input type="color" value={nieuw.kleur} onChange={e => setNieuw(p => ({ ...p, kleur: e.target.value }))}
              style={{ width: 36, height: 32, border: '1px solid #DDD', borderRadius: 4, cursor: 'pointer', padding: 2 }} />
          </div>
          <button style={S.btnBlue} onClick={voegToe} disabled={bezig || !nieuw.naam}>+ Toevoegen</button>
        </div>
        <Fout tekst={fout} />
      </div>

      <ZoekToggle zoek={zoek} setZoek={setZoek} toonInactief={toonInactief} setToonInactief={setToonInactief}
        placeholder="Zoeken op naam of beschrijving..." aantalInactief={inactiefAantal} />

      <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 8, overflow: 'hidden' }}>
        {gefilterd.length === 0 && <div style={{ padding: '20px 14px', color: '#AAA', fontStyle: 'italic', fontSize: 13 }}>Geen families gevonden</div>}
        {gefilterd.map((f, i) => (
          <div key={f.id} style={{ background: i % 2 === 0 ? '#fff' : '#FAFAFA', borderBottom: '1px solid #F0F0F0', padding: '10px 14px', opacity: f.actief ? 1 : 0.6 }}>
            {bewerk?.id === f.id ? (
              <div style={S.editBox}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr auto', gap: 10, alignItems: 'center', marginBottom: 10 }}>
                  <input style={S.input} placeholder="Naam" value={bewerk.naam} onChange={e => setBewerk(p => ({ ...p, naam: e.target.value }))} />
                  <input style={S.input} placeholder="Beschrijving" value={bewerk.beschrijving || ''} onChange={e => setBewerk(p => ({ ...p, beschrijving: e.target.value }))} />
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <label style={{ fontSize: 12 }}>Kleur</label>
                    <input type="color" value={bewerk.kleur || '#185FA5'} onChange={e => setBewerk(p => ({ ...p, kleur: e.target.value }))}
                      style={{ width: 36, height: 32, border: '1px solid #DDD', borderRadius: 4, cursor: 'pointer', padding: 2 }} />
                  </div>
                </div>
                <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center', marginBottom: 10, cursor: 'pointer' }}>
                  <input type="checkbox" checked={bewerk.actief} onChange={e => setBewerk(p => ({ ...p, actief: e.target.checked }))} /> Actief
                </label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button style={S.btnGreen} onClick={slaOp} disabled={bezig}>Opslaan</button>
                  <button style={S.btnGhost} onClick={() => { setBewerk(null); setFout(''); }}>Annuleren</button>
                </div>
                <Fout tekst={fout} />
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{ width: 16, height: 16, borderRadius: '50%', background: f.kleur, flexShrink: 0, border: '2px solid rgba(0,0,0,0.1)' }} />
                <div style={{ fontWeight: 600, fontSize: 13, minWidth: 130, color: f.actief ? '#1F3864' : '#AAA' }}>{f.naam}</div>
                <div style={{ fontSize: 12, color: '#666', flex: 1 }}>{f.beschrijving || <span style={{ color: '#CCC' }}>—</span>}</div>
                <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 99, background: f.actief ? '#EAF3DE' : '#F4F4F4', color: f.actief ? '#27500A' : '#AAA' }}>
                  {f.actief ? 'Actief' : 'Inactief'}
                </span>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button style={S.btnGhost} onClick={() => { setBewerk({ ...f }); setFout(''); }}>Bewerk</button>
                  <button style={{ ...S.btnGhost, color: f.actief ? '#C0392B' : '#1A7A3C', borderColor: f.actief ? '#E05040' : '#82C96B' }} onClick={() => toggleActief(f)}>
                    {f.actief ? 'Deactiveer' : 'Activeer'}
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <div style={{ marginTop: 8, fontSize: 12, color: '#AAA' }}>{gefilterd.length} van {lijst.length} families</div>
    </div>
  );
}

// ─── LEVERANCIERS ─────────────────────────────────────────────────────────────
function LeveranciersTab({ onTel }) {
  const [lijst, setLijst]   = useState([]);
  const [nieuw, setNieuw]   = useState({ naam: '', contactpersoon: '', email: '', telefoon: '' });
  const [bewerk, setBewerk] = useState(null);
  const [fout, setFout]     = useState('');
  const [bezig, setBezig]   = useState(false);
  const [zoek, setZoek]     = useState('');
  const [toonInactief, setToonInactief] = useState(false);

  const laad = () => api.get('/leveranciers').then(r => setLijst(r.data));
  useEffect(() => { laad(); }, []);
  useEffect(() => { onTel?.(lijst.filter(l => l.actief).length); }, [lijst]);

  const voegToe = async () => {
    if (!nieuw.naam) return;
    setBezig(true); setFout('');
    try { await api.post('/leveranciers', nieuw); setNieuw({ naam: '', contactpersoon: '', email: '', telefoon: '' }); laad(); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const slaOp = async () => {
    setBezig(true); setFout('');
    try { await api.put(`/leveranciers/${bewerk.id}`, bewerk); setBewerk(null); laad(); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const toggleActief = async (l) => {
    await api.put(`/leveranciers/${l.id}`, { ...l, actief: !l.actief }); laad();
  };

  const inactiefAantal = lijst.filter(l => !l.actief).length;
  const gefilterd = useMemo(() => lijst.filter(l => {
    if (!toonInactief && !l.actief) return false;
    if (zoek) {
      const q = zoek.toLowerCase();
      return `${l.naam} ${l.contactpersoon || ''} ${l.email || ''} ${l.telefoon || ''}`.toLowerCase().includes(q);
    }
    return true;
  }), [lijst, zoek, toonInactief]);

  const veld = (obj, setObj, key, placeholder, type = 'text') => (
    <input style={S.input} type={type} placeholder={placeholder} value={obj[key] || ''}
      onChange={e => setObj(p => ({ ...p, [key]: e.target.value }))} />
  );

  return (
    <div>
      <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 8, padding: 16, marginBottom: 16 }}>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, color: '#1F3864' }}>Nieuwe leverancier</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, marginBottom: 10 }}>
          {veld(nieuw, setNieuw, 'naam', 'Naam *')}
          {veld(nieuw, setNieuw, 'contactpersoon', 'Contactpersoon')}
          {veld(nieuw, setNieuw, 'email', 'E-mail', 'email')}
          {veld(nieuw, setNieuw, 'telefoon', 'Telefoon')}
        </div>
        <button style={S.btnBlue} onClick={voegToe} disabled={bezig || !nieuw.naam}>+ Toevoegen</button>
        <Fout tekst={fout} />
      </div>

      <ZoekToggle zoek={zoek} setZoek={setZoek} toonInactief={toonInactief} setToonInactief={setToonInactief}
        placeholder="Zoeken op naam, contactpersoon, e-mail..." aantalInactief={inactiefAantal} />

      <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 8, overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 140px 180px 120px 80px 120px', background: '#1F3864', color: '#fff', padding: '8px 14px', fontSize: 11, fontWeight: 500 }}>
          {['Naam', 'Contactpersoon', 'E-mail', 'Telefoon', 'Status', ''].map(h => <div key={h}>{h}</div>)}
        </div>
        {gefilterd.length === 0 && <div style={{ padding: '20px 14px', color: '#AAA', fontStyle: 'italic', fontSize: 13 }}>Geen leveranciers gevonden</div>}
        {gefilterd.map((l, i) => (
          <div key={l.id} style={{ background: i % 2 === 0 ? '#fff' : '#FAFAFA', borderBottom: '1px solid #F0F0F0', padding: '10px 14px', opacity: l.actief ? 1 : 0.6 }}>
            {bewerk?.id === l.id ? (
              <div style={S.editBox}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, marginBottom: 10 }}>
                  {veld(bewerk, setBewerk, 'naam', 'Naam')}
                  {veld(bewerk, setBewerk, 'contactpersoon', 'Contactpersoon')}
                  {veld(bewerk, setBewerk, 'email', 'E-mail', 'email')}
                  {veld(bewerk, setBewerk, 'telefoon', 'Telefoon')}
                </div>
                <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center', marginBottom: 10, cursor: 'pointer' }}>
                  <input type="checkbox" checked={bewerk.actief} onChange={e => setBewerk(p => ({ ...p, actief: e.target.checked }))} /> Actief
                </label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button style={S.btnGreen} onClick={slaOp} disabled={bezig}>Opslaan</button>
                  <button style={S.btnGhost} onClick={() => { setBewerk(null); setFout(''); }}>Annuleren</button>
                </div>
                <Fout tekst={fout} />
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 140px 180px 120px 80px 120px', alignItems: 'center', gap: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: l.actief ? '#1F3864' : '#AAA' }}>{l.naam}</div>
                <div style={{ fontSize: 12, color: '#555' }}>{l.contactpersoon || <span style={{ color: '#CCC' }}>—</span>}</div>
                <div style={{ fontSize: 12, color: '#555' }}>
                  {l.email ? <a href={`mailto:${l.email}`} style={{ color: '#185FA5', textDecoration: 'none' }}>{l.email}</a> : <span style={{ color: '#CCC' }}>—</span>}
                </div>
                <div style={{ fontSize: 12, color: '#555' }}>{l.telefoon || <span style={{ color: '#CCC' }}>—</span>}</div>
                <div>
                  <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 99, background: l.actief ? '#EAF3DE' : '#F4F4F4', color: l.actief ? '#27500A' : '#AAA' }}>
                    {l.actief ? 'Actief' : 'Inactief'}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: 5 }}>
                  <button style={S.btnGhost} onClick={() => { setBewerk({ ...l }); setFout(''); }}>Bewerk</button>
                  <button style={{ ...S.btnGhost, color: l.actief ? '#C0392B' : '#1A7A3C', borderColor: l.actief ? '#E05040' : '#82C96B' }} onClick={() => toggleActief(l)}>
                    {l.actief ? 'Deact.' : 'Activeer'}
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <div style={{ marginTop: 8, fontSize: 12, color: '#AAA' }}>{gefilterd.length} van {lijst.length} leveranciers</div>
    </div>
  );
}

// ─── MEDEWERKERS ──────────────────────────────────────────────────────────────
function MedewerkersTab({ huidigUser, onTel }) {
  const [lijst, setLijst]     = useState([]);
  const [nieuw, setNieuw]     = useState({ naam: '', email: '', wachtwoord: '', rol: 'werkvloer' });
  const [bewerk, setBewerk]   = useState(null);
  const [resetWw, setResetWw] = useState(null);
  const [fout, setFout]       = useState('');
  const [bezig, setBezig]     = useState(false);
  const [zoek, setZoek]       = useState('');
  const [toonInactief, setToonInactief] = useState(false);
  const isAdmin = huidigUser?.rol === 'admin';

  const laad = () => api.get('/gebruikers').then(r => setLijst(r.data));
  useEffect(() => { laad(); }, []);
  useEffect(() => { onTel?.(lijst.filter(g => g.actief).length); }, [lijst]);

  const voegToe = async () => {
    if (!nieuw.naam || !nieuw.email || !nieuw.wachtwoord) return;
    setBezig(true); setFout('');
    try { await api.post('/auth/register', nieuw); setNieuw({ naam: '', email: '', wachtwoord: '', rol: 'werkvloer' }); laad(); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const slaOp = async () => {
    setBezig(true); setFout('');
    try { await api.put(`/gebruikers/${bewerk.id}`, bewerk); setBewerk(null); laad(); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const resetWachtwoord = async () => {
    if (!resetWw?.wachtwoord || resetWw.wachtwoord.length < 6) { setFout('Wachtwoord moet minstens 6 tekens zijn'); return; }
    setBezig(true); setFout('');
    try { await api.post(`/gebruikers/${resetWw.id}/reset-wachtwoord`, { wachtwoord: resetWw.wachtwoord }); setResetWw(null); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const toggleActief = async (g) => {
    setFout('');
    try { await api.put(`/gebruikers/${g.id}`, { ...g, actief: !g.actief }); laad(); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
  };

  const verwijder = async (g) => {
    if (!window.confirm(`Gebruiker "${g.naam}" permanent verwijderen?`)) return;
    setFout('');
    try { await api.delete(`/gebruikers/${g.id}`); laad(); }
    catch (e) { setFout(e.response?.data?.error || e.message); }
  };

  const ROL = {
    admin:      { bg: '#EEEDFE', cl: '#3C3489', label: 'Admin' },
    planner:    { bg: '#E6F1FB', cl: '#0C447C', label: 'Planner' },
    werkvloer:  { bg: '#EAF3DE', cl: '#27500A', label: 'Werkvloer' },
    backoffice: { bg: '#FDF3E3', cl: '#854F0B', label: 'Backoffice' },
  };

  const initialen = (naam) => naam.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);

  const inactiefAantal = lijst.filter(g => !g.actief).length;
  const gefilterd = useMemo(() => lijst.filter(g => {
    if (!toonInactief && !g.actief) return false;
    if (zoek) return `${g.naam} ${g.email} ${g.rol}`.toLowerCase().includes(zoek.toLowerCase());
    return true;
  }), [lijst, zoek, toonInactief]);

  return (
    <div>
      {isAdmin && (
        <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 8, padding: 16, marginBottom: 16 }}>
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, color: '#1F3864' }}>Nieuwe medewerker</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: 10, marginBottom: 10 }}>
            <input style={S.input} placeholder="Naam *" value={nieuw.naam} onChange={e => setNieuw(p => ({ ...p, naam: e.target.value }))} />
            <input style={S.input} placeholder="E-mail *" type="email" value={nieuw.email} onChange={e => setNieuw(p => ({ ...p, email: e.target.value }))} />
            <input style={S.input} placeholder="Wachtwoord *" type="password" value={nieuw.wachtwoord} onChange={e => setNieuw(p => ({ ...p, wachtwoord: e.target.value }))} />
            <select value={nieuw.rol} onChange={e => setNieuw(p => ({ ...p, rol: e.target.value }))} style={{ ...S.input, width: 'auto' }}>
              <option value="werkvloer">Werkvloer</option>
              <option value="planner">Planner</option>
              <option value="backoffice">Backoffice</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <button style={S.btnBlue} onClick={voegToe} disabled={bezig || !nieuw.naam || !nieuw.email || !nieuw.wachtwoord}>+ Toevoegen</button>
          <Fout tekst={fout} />
        </div>
      )}

      <ZoekToggle zoek={zoek} setZoek={setZoek} toonInactief={toonInactief} setToonInactief={setToonInactief}
        placeholder="Zoeken op naam, e-mail, rol..." aantalInactief={inactiefAantal} />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {gefilterd.length === 0 && <div style={{ padding: '20px 14px', color: '#AAA', fontStyle: 'italic', fontSize: 13 }}>Geen medewerkers gevonden</div>}
        {gefilterd.map(g => {
          const rk = ROL[g.rol] || ROL.werkvloer;
          const isZichzelf = g.id === huidigUser?.id;
          return (
            <div key={g.id} style={{ background: '#fff', border: '1px solid #E8E8E8', borderRadius: 8, overflow: 'hidden', opacity: g.actief ? 1 : 0.65 }}>
              {bewerk?.id === g.id ? (
                <div style={{ padding: 14 }}>
                  <div style={S.editBox}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 10, marginBottom: 10 }}>
                      <div><label style={{ fontSize: 11, color: '#666' }}>Naam</label><input style={S.input} value={bewerk.naam} onChange={e => setBewerk(p => ({ ...p, naam: e.target.value }))} /></div>
                      <div><label style={{ fontSize: 11, color: '#666' }}>E-mail</label><input style={S.input} type="email" value={bewerk.email} onChange={e => setBewerk(p => ({ ...p, email: e.target.value }))} /></div>
                      <div>
                        <label style={{ fontSize: 11, color: '#666' }}>Rol</label>
                        <select value={bewerk.rol} onChange={e => setBewerk(p => ({ ...p, rol: e.target.value }))} style={{ ...S.input, width: 'auto' }}>
                          <option value="werkvloer">Werkvloer</option>
                          <option value="planner">Planner</option>
                          <option value="backoffice">Backoffice</option>
                          <option value="admin">Admin</option>
                        </select>
                      </div>
                    </div>
                    <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center', marginBottom: 10, cursor: 'pointer' }}>
                      <input type="checkbox" checked={bewerk.actief} onChange={e => setBewerk(p => ({ ...p, actief: e.target.checked }))} /> Actief
                    </label>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button style={S.btnGreen} onClick={slaOp} disabled={bezig}>Opslaan</button>
                      <button style={S.btnGhost} onClick={() => { setBewerk(null); setFout(''); }}>Annuleren</button>
                    </div>
                    <Fout tekst={fout} />
                  </div>
                </div>
              ) : resetWw?.id === g.id ? (
                <div style={{ padding: 14 }}>
                  <div style={S.editBox}>
                    <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>Wachtwoord resetten voor <strong>{g.naam}</strong></div>
                    <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                      <input style={{ ...S.input, maxWidth: 280 }} type="password" placeholder="Nieuw wachtwoord (min. 6 tekens)"
                        value={resetWw.wachtwoord} onChange={e => setResetWw(p => ({ ...p, wachtwoord: e.target.value }))} />
                      <button style={S.btnOrange} onClick={resetWachtwoord} disabled={bezig}>Instellen</button>
                      <button style={S.btnGhost} onClick={() => { setResetWw(null); setFout(''); }}>Annuleren</button>
                    </div>
                    <Fout tekst={fout} />
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '12px 16px' }}>
                  {/* Avatar */}
                  <div style={{
                    width: 38, height: 38, borderRadius: '50%', flexShrink: 0,
                    background: rk.bg, color: rk.cl, border: `2px solid ${rk.cl}40`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 13, fontWeight: 700,
                  }}>
                    {initialen(g.naam)}
                  </div>
                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                      <span style={{ fontWeight: 600, fontSize: 14, color: g.actief ? '#1F3864' : '#AAA' }}>
                        {g.naam}
                        {isZichzelf && <span style={{ fontSize: 10, color: '#888', marginLeft: 6, fontWeight: 400 }}>(jij)</span>}
                      </span>
                      <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 99, background: rk.bg, color: rk.cl, fontWeight: 600 }}>{rk.label}</span>
                      {!g.actief && <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 99, background: '#F4F4F4', color: '#AAA' }}>Inactief</span>}
                    </div>
                    <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{g.email}</div>
                  </div>
                  {/* Acties */}
                  {isAdmin && (
                    <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                      <button style={S.btnGhost} onClick={() => { setBewerk({ ...g }); setFout(''); setResetWw(null); }}>Bewerk</button>
                      <button style={S.btnOrange} onClick={() => { setResetWw({ id: g.id, wachtwoord: '' }); setFout(''); setBewerk(null); }}>Reset ww</button>
                      <button style={{ ...S.btnGhost, color: g.actief ? '#C0392B' : '#1A7A3C', borderColor: g.actief ? '#E05040' : '#82C96B' }} onClick={() => toggleActief(g)}>
                        {g.actief ? 'Deact.' : 'Activeer'}
                      </button>
                      {!isZichzelf && <button style={S.btnRed} onClick={() => verwijder(g)}>Wis</button>}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div style={{ marginTop: 8, fontSize: 12, color: '#AAA' }}>{gefilterd.length} van {lijst.length} medewerkers</div>
    </div>
  );
}

// ─── OPERATIETIJDEN ───────────────────────────────────────────────────────────
const DRIVERS = [
  { value: 'vast',            label: 'Vast (setup only)' },
  { value: 'per_stuk',        label: 'Per stuk' },
  { value: 'per_tand',        label: 'Per tand' },
  { value: 'per_mm',          label: 'Per mm diameter' },
  { value: 'order_specifiek', label: 'Order-specifiek' },
];

const DRIVER_KLEUR = {
  vast:            { bg: '#EEF0F5', color: '#444' },
  per_stuk:        { bg: '#E8F4FD', color: '#1A5E8A' },
  per_tand:        { bg: '#F0F9EE', color: '#1A6035' },
  per_mm:          { bg: '#FDF3E3', color: '#7A4500' },
  order_specifiek: { bg: '#FEF0F0', color: '#8A1A1A' },
};

function numVeld(val, onChange, width = 70) {
  return (
    <input
      type="number" min="0" step="0.01"
      value={val ?? 0}
      onChange={e => onChange(parseFloat(e.target.value) || 0)}
      style={{ width, padding: '4px 6px', border: '1px solid #CDD', borderRadius: 4, fontSize: 12, textAlign: 'right' }}
    />
  );
}

function OperatietijdenTab() {
  const [lijst, setLijst]   = useState([]);
  const [bewerk, setBewerk] = useState(null); // { ...operatie }
  const [bezig, setBezig]   = useState(false);
  const [fout, setFout]     = useState('');
  const [zoek, setZoek]     = useState('');

  const laad = () => api.get('/operaties').then(r => setLijst(r.data.filter(o => o.actief)));
  useEffect(() => { laad(); }, []);

  const slaOp = async () => {
    setBezig(true); setFout('');
    try {
      await api.patch(`/operaties/${bewerk.id}/tijden`, {
        tijdsdriver:           bewerk.tijdsdriver || 'vast',
        setup_min:             bewerk.setup_min || 0,
        operator_min_per_stuk: bewerk.operator_min_per_stuk || 0,
        machine_min_per_stuk:  bewerk.machine_min_per_stuk  || 0,
        operator_min_per_tand: bewerk.operator_min_per_tand || 0,
        machine_min_per_tand:  bewerk.machine_min_per_tand  || 0,
        operator_min_per_mm:   bewerk.operator_min_per_mm   || 0,
        machine_min_per_mm:    bewerk.machine_min_per_mm    || 0,
        operator_kostprijs_uur: bewerk.operator_kostprijs_uur || 0,
        machine_kostprijs_uur:  bewerk.machine_kostprijs_uur  || 0,
      });
      setBewerk(null);
      laad();
    } catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const b = bewerk;
  const set = (k, v) => setBewerk(p => ({ ...p, [k]: v }));

  const gefilterd = useMemo(() =>
    lijst.filter(o => !zoek || `${o.naam} ${o.categorie || ''}`.toLowerCase().includes(zoek.toLowerCase())),
    [lijst, zoek]
  );

  const totaalMin = (o, stuks = 1, tanden = 0, mm = 0) => {
    if (!o || o.tijdsdriver === 'order_specifiek') return null;
    const op =
      parseFloat(o.setup_min || 0) +
      parseFloat(o.operator_min_per_stuk || 0) * stuks +
      parseFloat(o.operator_min_per_tand || 0) * tanden * stuks +
      parseFloat(o.operator_min_per_mm   || 0) * mm * stuks;
    const mac =
      parseFloat(o.machine_min_per_stuk || 0) * stuks +
      parseFloat(o.machine_min_per_tand || 0) * tanden * stuks +
      parseFloat(o.machine_min_per_mm   || 0) * mm * stuks;
    return { op, mac };
  };

  const heeftTijden = (o) =>
    parseFloat(o.setup_min || 0) > 0 ||
    parseFloat(o.operator_min_per_stuk || 0) > 0 ||
    parseFloat(o.machine_min_per_stuk  || 0) > 0 ||
    parseFloat(o.operator_min_per_tand || 0) > 0 ||
    parseFloat(o.machine_min_per_tand  || 0) > 0 ||
    parseFloat(o.operator_min_per_mm   || 0) > 0 ||
    parseFloat(o.machine_min_per_mm    || 0) > 0;

  return (
    <div style={{ maxWidth: 1200 }}>
      <div style={{ background: '#EEF4FB', border: '1px solid #C5D8F0', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#1F3864' }}>
        <strong>Tijdsparameters per operatie</strong> — stel hier in hoeveel operator- en machinetijd elke operatie vraagt.
        Voor <em>draaien, frezen</em> en andere order-specifieke bewerkingen kies je "Order-specifiek": de planner vult de tijd dan per order in.
      </div>

      <input value={zoek} onChange={e => setZoek(e.target.value)} placeholder="Zoek operatie..."
        style={{ marginBottom: 12, padding: '7px 12px', border: '1px solid #DDD', borderRadius: 6, fontSize: 13, width: 280 }} />

      <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 8, overflow: 'hidden' }}>
        {/* Header */}
        <div style={{ display: 'grid', gridTemplateColumns: '40px 180px 130px 90px 160px 160px 120px', background: '#1F3864', color: '#fff', padding: '8px 14px', fontSize: 11, fontWeight: 500, gap: 0, alignItems: 'center' }}>
          <div>Nr.</div><div>Naam</div><div>Driver</div><div>Setup</div>
          <div>Operator (min)</div><div>Machine (min)</div><div></div>
        </div>
        {/* Subheader */}
        <div style={{ display: 'grid', gridTemplateColumns: '40px 180px 130px 90px 160px 160px 120px', background: '#2A4A78', color: '#B0C8E8', padding: '4px 14px', fontSize: 10, gap: 0, alignItems: 'center' }}>
          <div></div><div></div><div></div><div>min</div>
          <div>p/stuk · p/tand · p/mm</div>
          <div>p/stuk · p/tand · p/mm</div>
          <div></div>
        </div>

        {gefilterd.length === 0 && (
          <div style={{ padding: '20px 14px', color: '#AAA', fontStyle: 'italic', fontSize: 13 }}>Geen operaties gevonden</div>
        )}

        {gefilterd.map((o, i) => {
          const kleur = DRIVER_KLEUR[o.tijdsdriver || 'vast'];
          const heeft = heeftTijden(o);
          return (
            <div key={o.id} style={{ borderBottom: '1px solid #F0F0F0' }}>
              {bewerk?.id === o.id ? (
                /* ── Bewerk rij ── */
                <div style={{ padding: '12px 14px', background: '#F7F9FC', borderLeft: '3px solid #185FA5' }}>
                  <div style={{ fontWeight: 600, fontSize: 13, color: '#1F3864', marginBottom: 10 }}>
                    {o.nummer}. {o.naam}
                  </div>

                  {/* Driver selectie */}
                  <div style={{ marginBottom: 12 }}>
                    <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 4 }}>Tijdsdriver</label>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {DRIVERS.map(d => (
                        <button key={d.value} onClick={() => set('tijdsdriver', d.value)}
                          style={{
                            padding: '5px 11px', borderRadius: 6, fontSize: 12, cursor: 'pointer', border: '1px solid',
                            background: b.tijdsdriver === d.value ? DRIVER_KLEUR[d.value].bg : '#fff',
                            borderColor: b.tijdsdriver === d.value ? DRIVER_KLEUR[d.value].color : '#DDD',
                            color: b.tijdsdriver === d.value ? DRIVER_KLEUR[d.value].color : '#666',
                            fontWeight: b.tijdsdriver === d.value ? 600 : 400,
                          }}>
                          {d.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  {b.tijdsdriver !== 'order_specifiek' && (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 12 }}>
                      {/* Setup */}
                      <div>
                        <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 4 }}>Setup (min)</label>
                        {numVeld(b.setup_min, v => set('setup_min', v), 100)}
                      </div>

                      {/* Operator */}
                      <div>
                        <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 4 }}>Operator: min/stuk · min/tand · min/mm</label>
                        <div style={{ display: 'flex', gap: 6 }}>
                          {numVeld(b.operator_min_per_stuk, v => set('operator_min_per_stuk', v))}
                          {numVeld(b.operator_min_per_tand, v => set('operator_min_per_tand', v))}
                          {numVeld(b.operator_min_per_mm,   v => set('operator_min_per_mm',   v))}
                        </div>
                      </div>

                      {/* Machine */}
                      <div>
                        <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 4 }}>Machine: min/stuk · min/tand · min/mm</label>
                        <div style={{ display: 'flex', gap: 6 }}>
                          {numVeld(b.machine_min_per_stuk, v => set('machine_min_per_stuk', v))}
                          {numVeld(b.machine_min_per_tand, v => set('machine_min_per_tand', v))}
                          {numVeld(b.machine_min_per_mm,   v => set('machine_min_per_mm',   v))}
                        </div>
                      </div>
                    </div>
                  )}

                  {b.tijdsdriver === 'order_specifiek' && (
                    <div style={{ padding: '10px 14px', background: '#FEF0F0', border: '1px solid #F0BABA', borderRadius: 6, fontSize: 13, color: '#8A1A1A', marginBottom: 12 }}>
                      De planner vult de geschatte tijd handmatig in per order.
                    </div>
                  )}

                  {/* Kostprijzen */}
                  <div style={{ display: 'flex', gap: 16, marginBottom: 12 }}>
                    <div>
                      <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 4 }}>Operator kostprijs (€/uur)</label>
                      {numVeld(b.operator_kostprijs_uur, v => set('operator_kostprijs_uur', v), 90)}
                    </div>
                    <div>
                      <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 4 }}>Machine kostprijs (€/uur)</label>
                      {numVeld(b.machine_kostprijs_uur, v => set('machine_kostprijs_uur', v), 90)}
                    </div>
                  </div>

                  {fout && <Fout tekst={fout} />}
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button style={S.btnGreen} onClick={slaOp} disabled={bezig}>Opslaan</button>
                    <button style={S.btnGhost} onClick={() => { setBewerk(null); setFout(''); }}>Annuleren</button>
                  </div>
                </div>
              ) : (
                /* ── Weergave rij ── */
                <div style={{
                  display: 'grid', gridTemplateColumns: '40px 180px 130px 90px 160px 160px 120px',
                  padding: '9px 14px', alignItems: 'center', gap: 0,
                  background: i % 2 === 0 ? '#fff' : '#FAFAFA',
                  cursor: 'pointer',
                }} onDoubleClick={() => setBewerk({ ...o })}>
                  <div style={{ fontSize: 12, color: '#888' }}>{o.nummer}</div>
                  <div style={{ fontSize: 13, fontWeight: 500, color: '#1F3864' }}>{o.naam}</div>
                  <div>
                    <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 99, background: kleur.bg, color: kleur.color, fontWeight: 500 }}>
                      {DRIVERS.find(d => d.value === (o.tijdsdriver || 'vast'))?.label.replace(' (setup only)', '') || '—'}
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: '#444' }}>
                    {parseFloat(o.setup_min || 0) > 0 ? `${parseFloat(o.setup_min).toFixed(0)}'` : <span style={{ color: '#CCC' }}>—</span>}
                  </div>
                  {o.tijdsdriver === 'order_specifiek' ? (
                    <div style={{ fontSize: 11, color: '#888', fontStyle: 'italic', gridColumn: '5 / 7' }}>handmatig per order</div>
                  ) : (
                    <>
                      <div style={{ fontSize: 11, color: '#555', display: 'flex', gap: 4 }}>
                        {[o.operator_min_per_stuk, o.operator_min_per_tand, o.operator_min_per_mm].map((v, idx) => (
                          <span key={idx} style={{ minWidth: 38, textAlign: 'right', color: parseFloat(v || 0) > 0 ? '#185FA5' : '#CCC' }}>
                            {parseFloat(v || 0) > 0 ? parseFloat(v).toFixed(2) : '—'}
                          </span>
                        ))}
                      </div>
                      <div style={{ fontSize: 11, color: '#555', display: 'flex', gap: 4 }}>
                        {[o.machine_min_per_stuk, o.machine_min_per_tand, o.machine_min_per_mm].map((v, idx) => (
                          <span key={idx} style={{ minWidth: 38, textAlign: 'right', color: parseFloat(v || 0) > 0 ? '#267A5C' : '#CCC' }}>
                            {parseFloat(v || 0) > 0 ? parseFloat(v).toFixed(2) : '—'}
                          </span>
                        ))}
                      </div>
                    </>
                  )}
                  <div>
                    <button style={S.btnGhost} onClick={() => setBewerk({ ...o })}>
                      {heeft || o.tijdsdriver !== 'vast' ? '✏️ Bewerk' : '+ Tijden'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div style={{ marginTop: 8, fontSize: 12, color: '#AAA' }}>{gefilterd.length} actieve operaties</div>
    </div>
  );
}

// ─── HOOFD COMPONENT ──────────────────────────────────────────────────────────
export default function InstellingenPage({ user }) {
  const [tab, setTab] = useState('operaties');
  const [tellers, setTellers] = useState({});

  const tabs = [
    { key: 'operaties',      label: 'Operaties' },
    { key: 'operatietijden', label: 'Operatietijden' },
    { key: 'families',       label: 'Productfamilies' },
    { key: 'leveranciers',   label: 'Leveranciers' },
    { key: 'gebruikers',     label: 'Medewerkers' },
  ];

  return (
    <div style={{ padding: 24, maxWidth: tab === 'operatietijden' ? 1300 : 1100 }}>
      <h1 style={{ margin: '0 0 20px', fontSize: 20, fontWeight: 600, color: '#1F3864' }}>Instellingen</h1>

      <div style={{ borderBottom: '1px solid #E0E0E0', marginBottom: 20, display: 'flex', gap: 0 }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '9px 18px', border: 'none',
            borderBottom: tab === t.key ? '2.5px solid #185FA5' : '2.5px solid transparent',
            background: 'none', fontSize: 13,
            fontWeight: tab === t.key ? 600 : 400,
            color: tab === t.key ? '#185FA5' : '#555',
            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
          }}>
            {t.label}
            {tellers[t.key] != null && (
              <span style={{
                fontSize: 11, padding: '1px 7px', borderRadius: 99,
                background: tab === t.key ? '#185FA5' : '#EEE',
                color: tab === t.key ? '#fff' : '#666',
              }}>{tellers[t.key]}</span>
            )}
          </button>
        ))}
      </div>

      {tab === 'operaties'      && <OperatiesTab    onTel={n => setTellers(t => ({ ...t, operaties: n }))} />}
      {tab === 'operatietijden' && <OperatietijdenTab />}
      {tab === 'families'       && <FamiliesTab     onTel={n => setTellers(t => ({ ...t, families: n }))} />}
      {tab === 'leveranciers'   && <LeveranciersTab onTel={n => setTellers(t => ({ ...t, leveranciers: n }))} />}
      {tab === 'gebruikers'     && <MedewerkersTab  huidigUser={user} onTel={n => setTellers(t => ({ ...t, gebruikers: n }))} />}
    </div>
  );
}
